import { api } from './client'
import type { Chat } from '../types'

export const chatsApi = {
  list: (folder = 'inbox', updatedSince?: string): Promise<{ chats: Chat[] }> =>
    api.get(
      `/v1/messaging/chats?folder=${folder}${updatedSince ? `&updated_since=${encodeURIComponent(updatedSince)}` : ''}`,
    ),

  getOrCreate: (peerId: string): Promise<Chat> =>
    api.post('/v1/messaging/chats', { peer_id: peerId }),

  // Синхронно создаёт чат группы в messaging (id = group_id) и добавляет вызывающего.
  createGroupChat: (groupId: string): Promise<Chat> =>
    api.post('/v1/messaging/chats/group', { group_id: groupId }),

  // Синхронно добавляет/удаляет участника чата группы в messaging
  // (вызывать вместе с groups.addMember/kick/leave, чтобы участник сразу
  // получал сообщения и видел группу без ожидания Kafka).
  addGroupMember: (groupId: string, userId: string): Promise<void> =>
    api.post('/v1/messaging/chats/group/members', { group_id: groupId, user_id: userId }),

  removeGroupMember: (groupId: string, userId: string): Promise<void> =>
    api.delete(`/v1/messaging/chats/group/${groupId}/members/${userId}`),

  updateSettings: (
    chatId: string,
    data: { is_pinned?: boolean; is_muted?: boolean; mute_until?: string | null; folder?: string },
  ) => api.patch(`/v1/messaging/chats/${chatId}/settings`, data),

  markRead: (chatId: string, lastMessageId: string) =>
    api.post(`/v1/messaging/chats/${chatId}/read`, { last_message_id: lastMessageId }),

  getPinned: (chatId: string) =>
    api.get(`/v1/messaging/chats/${chatId}/pinned`),

  pinMessage: (chatId: string, messageId: string) =>
    api.post(`/v1/messaging/chats/${chatId}/messages/${messageId}/pin`, {}),

  unpinMessage: (chatId: string, messageId: string) =>
    api.delete(`/v1/messaging/chats/${chatId}/messages/${messageId}/pin`),
}
